export interface Permissions {
  permissions: string[];
}

export interface SpotfightUser {
  user_id: string,
  full_name: string,
  email: string,
  email_verified: boolean,
  allowed_actions: Permissions,
  is_patreon: boolean,
  is_youtube_member: boolean
}

export interface SpotfightQuestion {
  uuid: string,
  content: string,
  sub_content: string,
  points: string,
  options: string[],
  correct: number

  /*Temporary for easier use*/
  selected?: number
}

export interface SpotfightEvent {
  uuid: string,
  event_name: string,
  description: string,
  league: string,
  deadline: Date,
  image_uri: string,
  closed: boolean,
  live: boolean,
  questions: SpotfightQuestion[],

  image_content?: Object,
  timeLeft?: number
}


export interface Vote {
  [key: string]: number;
}

export interface Votes {
  event_uuid: string,
  user_id: string,
  display_name: string,
  votes: Vote
}

export class ScoreEntry {
  display_name: string;
  user_id: string;
  points: number;
  rank?: number; // Optional
  winner?: boolean; // Optional

  constructor(display_name: string, user_id: string, points: number, rank?: number, winner?: boolean) {
    this.display_name = display_name;
    this.user_id = user_id;
    this.points = points;
    this.rank = rank;
    this.winner = winner;
  }
}

export class Scoreboard {
  scores: ScoreEntry[];
  last_key: string | undefined;

  constructor() {
    this.scores = [];
  }

  // Method to add a ScoreEntry to scores
  addScore(score: ScoreEntry) {
    this.scores.push(score);
  }
}

export interface UserScore {
  user_id: string;
  rank?: number;
  points?: number;
}

export enum Actions {
  EVENTS_LIST = "events:list",
  EVENTS_LIST_NON_LIVE = "events:list_non_live",
  EVENTS_CREATE = "events:create",
  EVENTS_GET = "events:get",
  EVENTS_UPDATE = "events:update",
  EVENTS_DELETE = "events:delete",
  EVENTS_GO_LIVE = "events:go_live",
  USERS_GET = "users:get",
  USERS_UPDATE = "users:update",
  USERS_DELETE = "users:delete",
  USERS_LIST = "users:list",
  USERS_PROFILE = "users:profile",
  VOTES_CREATE = "votes:create",
  VOTES_LIST = "votes:list",
  VOTES_GET = "votes:get",
  VOTES_LIST_FOR_EVENT = "votes:list_for_event",
  VOTES_EVALUATE = "votes:evaluate",
  YOUTUBE_MEMBERS_LIST_UPLOAD = "youtube_members:upload",
  SCOREBOARD_ALL = "scoreboard:all",
  EMAIL_SEND = "email:send",
  ADMIN_UI = "admin:ui",
  ADMIN_RESET = "admin:reset",
  ADMIN_PATREON_SEASON = "admin:patreon_season",
  ADMIN_UPLOAD_BANNER = "admin:upload_banner"
}

export interface SpotfightBackendError {
  code: string;
  text: number;
}

export const ERROR_MESSAGES: { [key: string]: string } = {
  "E001": "Es konnte kein Youtube Profile für diesen Account gefunden werden!",
  "E002": "Unauthorized!",
  "E003": "Unbekannter Fehler! Bitte wende dich an den Systemadministrator.",
  "E004": "Fehler beim Aufruf der Patreon API. Bitte versuche es später erneut oder kontaktiere den Support.",
  "E005": "Patreon Account hat keine Mitgleidschaften",
  "E006": "Es konnte keine aktive Patreon Mitgliedschaft gefunden werden.",
  "E007": "Youtube Profil hat keine aktive Spotfight Subscription"
}

export interface AsyncTaskInfo {
  task_id: string,
  timestamp: string,
  status: string,
  error_message: string
}

export interface PatreonSeason {
  season_start: Date,
  highest_tier_amount: number
  prices_url: string
}

export interface PricesUrl {
  url: string
}

